import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Figure } from '@studiometa/ui';
import Home from '#js/organisms/Home.js';
import Single from '#js/organisms/Single.js';
import { isDev } from '#js/config.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./molecules/Video.js').default>>
 *     Accordion: Array<Promise<import('./molecules/Accordion.js').default>>
 *     Slider: Array<Promise<import('./molecules/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @extends {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Figure,
      Home,
      Single,
      Slider: (app) => importWhenVisible(() => import('./molecules/Slider.js'), 'Slider', app),
      Video: (app) => importWhenVisible(() => import('./molecules/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion.js'), 'Accordion', app),
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    setTimeout(() => {
      document.body.classList.remove('show-panel');
      /* eslint-disable unicorn/no-document-cookie */
      document.cookie = 'visited=1';
    }, 500);
  }
}

export default createApp(App, document.body);
